import React from 'react';
import './index.css';
import splashscreenicon from '../../assests/karaicon.svg'; 

const SplashScreen = ({ onNavigate, fadeOut }) => {
  return (
    <div className={`splash-screen ${fadeOut ? 'splash-fade-out' : ''}`}>
      <div className="splash-content">
        <img 
          src={splashscreenicon} 
          alt="Splash Icon" 
          className="splash-icon" 
        />
        <button 
          className="splash-button" 
          onClick={onNavigate}
        >
          <span className="splash-text">Explore the Mastery</span>
          <span className="splash-button-arrow">→</span>
        </button>
      </div>
    </div>
  );
};

export default SplashScreen;